import {
  calculateTileOwnRiskPositionPriorityAndVisibility,
  calculateTileMessagesPositionPriorityAndVisibility,
  calculateTileInfoTitlePositionPriorityAndVisibility,
  calculateTileArrangeImmediatelyPositionPriorityAndVisibility,
  calculateTileInfoTitleAndParagraphPositionPriorityAndVisibility,
  calculateTileOpenInvoicesPositionPriorityAndVisibility,
  calculateTilePaymentArrangementPositionPriorityAndVisibility,
  calculateTileGoodNewsPositionPriorityAndVisibility,
  calculateTileEhicPositionPriorityAndVisibility,
  calculateTileDeclarationPositionPriorityAndVisibility,
  calculateTileInsuranceRightPositionPriorityAndVisibility,
  calculateRequestPolicyPositionPriorityAndVisibility,
  calculateTileYourInsurancePositionPriorityAndVisibility,
  calculateTileFysioSelfCheckPositionPriorityAndVisibility,
  calculateTileDamageInsurancePositionPriorityAndVisibility,
  calculateTileHealthcareContractsPositionPriorityAndVisibility,
} from 'src/utils/tile';
import { contentAxiosInstance } from 'src/boot/axios';

/**
 * @description Get items
 * @returns {void}
 */
export function getItems({ commit, dispatch }) {
  if (this.state.items?.length > 0) return;
  commit('setLoading', true);

  contentAxiosInstance.get('/frontend-content/tiles/tiles.json').then((response) => {
    commit('setItems', response.data);
    commit('setLoading', false);
    dispatch('calculatePositionPriorityAndVisibilityForTiles');
  });
}

export function calculatePositionPriorityAndVisibilityForTiles({ commit, state }) {
  const items = state.items;
  if (!items) return;
  const _updatedItems = items.map((item) => {
    let positionPriorityAndVisibility = {};
    switch (item.type) {
      case 'own-risk':
        positionPriorityAndVisibility = calculateTileOwnRiskPositionPriorityAndVisibility(item);
        break;
      case 'messages':
        positionPriorityAndVisibility = calculateTileMessagesPositionPriorityAndVisibility(item);
        break;
      case 'open-invoices':
        positionPriorityAndVisibility = calculateTileOpenInvoicesPositionPriorityAndVisibility(item);
        break;
      case 'good-news':
        positionPriorityAndVisibility = calculateTileGoodNewsPositionPriorityAndVisibility(item);
        break;
      case 'payment-arrangement':
        positionPriorityAndVisibility = calculateTilePaymentArrangementPositionPriorityAndVisibility(item);
        break;
      case 'ehic':
        positionPriorityAndVisibility = calculateTileEhicPositionPriorityAndVisibility(item);
        break;
      case 'declaration':
        positionPriorityAndVisibility = calculateTileDeclarationPositionPriorityAndVisibility(item);
        break;
      case 'insurance-right':
        positionPriorityAndVisibility = calculateTileInsuranceRightPositionPriorityAndVisibility(item);
        break;
      case 'tile-info-title':
        positionPriorityAndVisibility = calculateTileInfoTitlePositionPriorityAndVisibility(item);
        break;
      case 'arrange-immediately':
        positionPriorityAndVisibility = calculateTileArrangeImmediatelyPositionPriorityAndVisibility(item);
        break;
      case 'tile-info-title-and-paragraph':
        positionPriorityAndVisibility = calculateTileInfoTitleAndParagraphPositionPriorityAndVisibility(item);
        break;
      case 'request-policy':
        positionPriorityAndVisibility = calculateRequestPolicyPositionPriorityAndVisibility(item);
        break;
      case 'your-insurance':
        positionPriorityAndVisibility = calculateTileYourInsurancePositionPriorityAndVisibility(item);
        break;
      case 'fysio-self-check':
        positionPriorityAndVisibility = calculateTileFysioSelfCheckPositionPriorityAndVisibility(item);
        break;
      case 'damage-insurance':
        positionPriorityAndVisibility = calculateTileDamageInsurancePositionPriorityAndVisibility(item);
        break;
      case 'healthcare-contracts':
        positionPriorityAndVisibility = calculateTileHealthcareContractsPositionPriorityAndVisibility(item);
        break;
      default:
        break;
    }
    return {
      ...item,
      calculatedValues: positionPriorityAndVisibility,
    };
  });
  commit('setItems', _updatedItems);
}
